import { useEffect } from "react";
import { useNotifications, useSidebar } from "@hooks";
import { Box, Fade, useDisclosure } from "@chakra-ui/react";
import { NotificationItem } from "@components";

const CHAT_TAB_INDEX = 2;
const MESSAGE_BANNER_VISIBLE_MS = 5000;
const DEFAULT_BANNER_VISIBLE_MS = 2000;

const NotificationViewer = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { chatNotification } = useNotifications();
  const { isSidebarOpen, handleSidebarToggle, handleTabIndex } = useSidebar();

  const isMessageNotification = chatNotification.type === "message";

  const handleNotificationClick = () => {
    if (!isMessageNotification) return;
    if (!isSidebarOpen) handleSidebarToggle();
    handleTabIndex(CHAT_TAB_INDEX);
    onClose();
  };

  useEffect(() => {
    if (Object.keys(chatNotification).length === 0) {
      // The slot can be emptied by someone else (Clear all, the chat banner
      // middleware). Without this the banner stays open showing nothing.
      onClose();
      return undefined;
    }

    onOpen();

    const visibleMs =
      chatNotification.type === "message"
        ? MESSAGE_BANNER_VISIBLE_MS
        : DEFAULT_BANNER_VISIBLE_MS;
    const hideTimer = setTimeout(onClose, visibleMs);

    // Without this the previous toast's timer closes the current one early.
    return () => clearTimeout(hideTimer);
  }, [chatNotification, onOpen, onClose]);

  return (
    <Box
      width="330px"
      transition="width 0.3s cubic-bezier(0.820, 0.085, 0.395, 0.895)"
      height="calc(100vh - 600px)"
      maxHeight="12"
      position="absolute"
      bottom="200"
      left="0"
      zIndex={1}
      p="0 10px"
      pointerEvents="none"
    >
      <Fade in={isOpen} unmountOnExit={true} style={{ pointerEvents: "auto" }}>
        <NotificationItem
          notification={chatNotification}
          onClose={onClose}
          containerProps={{
            borderRadius: "12px",
            bgGradient:
              "linear-gradient(268.84deg, #253157 7.81%, #2B385F 82.5%)",
            ...(isMessageNotification && {
              onClick: handleNotificationClick,
              cursor: "pointer",
            }),
          }}
          buttonProps={{ bg: "#000C3B", color: "#555D7C" }}
        />
      </Fade>
    </Box>
  );
};

export default NotificationViewer;
